<div class="cashbook-app-container">
    <g3p-header></g3p-header>
    <router-outlet></router-outlet>
</div>
